import { AnalyteStatus, IAnalyte } from "../../domain/analyte.interface";

/**
 * SIMS-8839 — what the cup editor may offer (FR-43).
 *
 * An inactive analyte is never a NEW choice. One the saved cup already carries stays in the list,
 * so unchecking it by mistake can be undone before saving; an active-only filter would lose it for
 * good the moment it was unchecked. The server applies the same rule on save.
 */
export const isInactiveAnalyte = (analyte: IAnalyte): boolean =>
	analyte.status !== undefined && analyte.status !== AnalyteStatus.ACTIVE;

export const selectableAnalytes = (
	analytes: IAnalyte[],
	carriedIds: string[],
): IAnalyte[] => {
	const carried = new Set(carriedIds);
	return analytes.filter((a) => !isInactiveAnalyte(a) || carried.has(a._id));
};

/**
 * The FR-43 refusal from the server: a 400 whose message names the analytes. Read from the
 * unwrapped body the cup service rejects with, or from the axios shape.
 */
export const inactiveAnalyteMessage = (error: unknown): string | null => {
	const e = error as {
		statusCode?: number;
		message?: unknown;
		response?: { status?: number; data?: { message?: unknown } };
	};
	const status = e?.statusCode ?? e?.response?.status;
	const message = e?.response ? e.response.data?.message : e?.message;
	return status === 400 &&
		typeof message === "string" &&
		/can't be added to a cup/i.test(message)
		? message
		: null;
};
